import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { CartProvider } from './component/CartContext';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { ToastProvider } from './component/ToastContext';
//import { BrowserRouter, Routes, Route } from "react-router-dom";



import './config';

// Lazy load non-critical CSS
const loadCss = (href) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.media = 'print'; // prevent render-blocking
  link.onload = () => { link.media = 'all'; };
  document.head.appendChild(link);
};

// Load Cart.css and Fontello.css lazily
loadCss('./css/Cart.css');
loadCss('./fontello/css/fontello.css');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <CartProvider>
        <App />
      </CartProvider>
      <ToastContainer rtl />
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();
